
(function(){
function boot(root){
var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var reveals=(root||document).querySelectorAll('[data-dgc-reveal]');
if(!reduce&&'IntersectionObserver'in window){
var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('dgc-visible');io.unobserve(e.target)}})},{rootMargin:'0px 0px -45px 0px',threshold:.04});
reveals.forEach(function(el){io.observe(el)});
}else{reveals.forEach(function(el){el.classList.add('dgc-visible')})}
(root||document).querySelectorAll('.dgc-hero__video,.dgc-film__video').forEach(function(video){
if(video.dataset.dgcVideoBound==='true')return;
video.dataset.dgcVideoBound='true';
var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var conn=navigator.connection;
var connectionSlow=conn&&/^(slow-2g|2g|3g)$/.test(conn.effectiveType||'');
var allowVideo=!reduce&&!(conn&&conn.saveData)&&!connectionSlow;
var button=video.closest('.dgc-film__media')?.querySelector('[data-dgc-film-toggle]');
var userPaused=false;
function prepare(){
var deferred=video.querySelector('source[data-dgc-src]');
if(deferred&&!deferred.src){deferred.src=deferred.getAttribute('data-dgc-src');video.load()}
video.muted=true;
}
function syncButton(){
if(!button)return;
var playing=!video.paused&&!video.ended;
button.setAttribute('aria-pressed',playing?'true':'false');
button.setAttribute('aria-label',playing?'Pause film':'Play film');
var label=button.querySelector('.dgc-film__toggle-label');
if(label)label.textContent=playing?'Pause film':'Play film';
}
function tryPlay(){
if(!document.hidden&&!userPaused){prepare();video.play().catch(function(){syncButton()})}
}
video.addEventListener('play',syncButton);
video.addEventListener('pause',syncButton);
video.addEventListener('ended',syncButton);
video.addEventListener('error',function(){video.pause();if(button)button.hidden=true;video.style.opacity='0'},{once:true});
if(button)button.addEventListener('click',function(){
if(video.paused){userPaused=false;tryPlay()}else{userPaused=true;video.pause()}
});
if(allowVideo){
if('IntersectionObserver'in window){
var vobs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)tryPlay();else video.pause()})},{threshold:.15});
vobs.observe(video);
}else tryPlay();
}else{video.pause();video.removeAttribute('autoplay')}
syncButton();
});
(root||document).querySelectorAll('[data-dgc-gift-story]').forEach(function(story){
if(story.dataset.dgcStoryBound==='true')return;
story.dataset.dgcStoryBound='true';
var btn=story.querySelector('[data-dgc-gift-control]');
if(!btn)return;
btn.addEventListener('click',function(){
var paused=story.classList.toggle('is-paused');
btn.setAttribute('aria-pressed',paused?'true':'false');
btn.setAttribute('aria-label',paused?'Play the animated gift story':'Pause the animated gift story');
var label=btn.querySelector('.dgc-gift-story__control-text');
if(label)label.textContent=paused?'Play':'Pause';
});
});
(root||document).querySelectorAll('.dgc-mobile-menu a').forEach(function(link){link.addEventListener('click',function(){var d=link.closest('details');if(d)d.open=false})});
if(!reduce&&window.matchMedia('(hover: hover) and (pointer: fine)').matches){
(root||document).querySelectorAll('.dgc-product-card').forEach(function(card){
card.style.transition='transform .35s ease';
var frame=0,tx=0,ty=0;
card.addEventListener('pointermove',function(ev){
var box=card.getBoundingClientRect(),x=(ev.clientX-box.left)/box.width-.5,y=(ev.clientY-box.top)/box.height-.5;
tx=(-y*2.6).toFixed(2);ty=(x*2.6).toFixed(2);
if(!frame){frame=requestAnimationFrame(function(){card.style.transform='perspective(1100px) rotateX('+tx+'deg) rotateY('+ty+'deg)';frame=0})}
},{passive:true});
card.addEventListener('pointerleave',function(){if(frame)cancelAnimationFrame(frame);frame=0;card.style.transform=''});
card.addEventListener('focusout',function(){card.style.transform=''});
});
}
}
function init(){document.documentElement.classList.add('dgc-js');boot(document)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
